/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { ReactComponent as WarningIcon } from 'Assets/svg/warning-rounded-icon.svg';

function EmailVerificationMessage() {
  return (
    <div className="email-verification-message">
      <div className="alert-wrapper">
        <WarningIcon />
        <span className="alert-message">
          Sorry, we couldn't verify this email
        </span>
      </div>
    </div>
  );
}

export default EmailVerificationMessage;
